import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './SelectAuth.scss';

const SelectAuth = ({ titles, routes }) => {
    return (
        <div className="select-auth">
            <div className="select-auth__item">
                <NavLink className='nav-link' to={routes[0]}>{titles[0]}</NavLink>
            </div>
            <div className="select-auth__item">
                <NavLink className='nav-link' to={routes[1]}>{titles[1]}</NavLink>
            </div>
        </div>
    );
};

export default SelectAuth;

SelectAuth.propTypes = {
    titles: PropTypes.array,
    routes: PropTypes.array
};